/* Click N Pop cart page: change quantities in place, then redraw the cart section from Shopify. */
(function () {
  'use strict';

  var root = document.querySelector('[data-cnp-cart]');
  if (!root) return;
  var sectionId = root.getAttribute('data-section');
  var timers = {};
  var stickyObserver = null;

  // Quantity buttons and typed quantities wait a moment, so several taps send one request
  function queue(key, quantity) {
    clearTimeout(timers[key]);
    timers[key] = setTimeout(function () { change(key, quantity); }, 350);
  }

  function change(key, quantity) {
    var line = root.querySelector('[data-key="' + CSS.escape(key) + '"]');
    if (line) line.classList.add('is-busy');
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: [sectionId], sections_url: window.location.pathname })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Could not update the cart.');
          return data;
        });
      })
      .then(function (cart) {
        var html = cart.sections && cart.sections[sectionId];
        if (!html) { window.location.reload(); return; }
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cnp-cart]');
        root.innerHTML = fresh.innerHTML;
        document.querySelectorAll('.c3-cart__count').forEach(function (el) { el.textContent = cart.item_count; });
        document.querySelectorAll('.c3-cart').forEach(function (el) { el.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items'); });
        watchSticky();
      })
      .catch(function (err) {
        if (line) line.classList.remove('is-busy');
        var box = root.querySelector('[data-cart-error]');
        if (box) {
          box.textContent = err.message;
          box.hidden = false;
        }
      });
  }

  root.addEventListener('click', function (event) {
    var step = event.target.closest('[data-step]');
    if (step) {
      var line = step.closest('[data-key]');
      var input = line.querySelector('[data-qty]');
      var next = Math.max(0, Math.min(99, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-step'), 10)));
      input.value = next;
      queue(line.getAttribute('data-key'), next);
      return;
    }
    var remove = event.target.closest('[data-remove]');
    if (remove) {
      event.preventDefault();
      change(remove.closest('[data-key]').getAttribute('data-key'), 0);
    }
  });

  root.addEventListener('change', function (event) {
    var input = event.target.closest('[data-qty]');
    if (!input) return;
    var qty = Math.max(0, Math.min(99, parseInt(input.value, 10) || 0));
    input.value = qty;
    queue(input.closest('[data-key]').getAttribute('data-key'), qty);
  });

  // Phone bottom bar: shown while the summary's Check out button is off screen
  function watchSticky() {
    if (stickyObserver) stickyObserver.disconnect();
    var sticky = root.querySelector('[data-cart-sticky]');
    var main = root.querySelector('[data-checkout]');
    if (!sticky || !main || !('IntersectionObserver' in window)) return;
    var button = sticky.querySelector('button');
    stickyObserver = new IntersectionObserver(function (entries) {
      var off = !entries[0].isIntersecting;
      sticky.classList.toggle('is-shown', off);
      sticky.setAttribute('aria-hidden', off ? 'false' : 'true');
      button.tabIndex = off ? 0 : -1;
    });
    stickyObserver.observe(main);
  }

  watchSticky();
})();
